import { render, staticRenderFns } from "./AnotadosMesaExamenListaItem.vue?vue&type=template&id=56eee7a5&"
import script from "./AnotadosMesaExamenListaItem.vue?vue&type=script&lang=js&"
export * from "./AnotadosMesaExamenListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports